import { styled } from '@mui/material';

export const Container = styled('div')({
  margin: '20px 0',
  '.follow-up-status-chip': {
    display: 'inline-flex'
  }
});

export const ClickableDescription = styled('span')({
  cursor: 'pointer',
  color: '#0675DD'
});
